import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Product from '../views/Proudct.vue'
import News from '../views/News.vue'
import New from '../views/New.vue'
import Cooperative from '../views/Cooperative.vue'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import About from '../views/About.vue';
import Contact from '../views/Contact.vue'; // 导入Contact组件
import Honors from '../views/Honors.vue'; // 导入Honors组件
import ProjectDetail from '../views/ProjectDetail.vue'; // 导入项目详情组件

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/news',
    name: 'news',
    component: News,
  },
  {
    path: '/product',
    name: 'product',
    component: Product,
  },
  {
    path: '/news/:id',
    name: 'new',
    component: New,
  },
  {
    path:'/cooperative',
    name:'cooperative',
    component: Cooperative
  },
  { path: '/about', name: 'About', component: About },
  { path: '/contact', name: 'Contact', component: Contact }, // 添加Contact路由
  { path: '/honors', name: 'Honors', component: Honors }, // 添加Honors路由
  { path: '/project/:id', name: 'projectDetail', component: ProjectDetail }, // 添加项目详情路由
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

// 路由加载的时候，使用页面加载进度工具进行监测：
router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})
// 路由加载完毕的时候，结束页面加载进度工具的监控：
router.afterEach((to, from, next) => {
  NProgress.done()
})

export default router
